import { registerApplication } from 'single-spa';
import { queryClient } from '../config/query_client';
const commonProps = {
    appId: 'bif',
    landscape: window.bifrostWeb.landscape,
    backend: window.bifrostWeb.backend,
    queryClient,
};
export const registerModule = ({ name, isAlwaysActive = false, props = {} }) => {
    const jsModuleName = `@bifrost/${name}`;
    const cssModuleName = `@bifrost/${name}-styles`;
    registerApplication({
        name: jsModuleName,
        app: () => System.import(jsModuleName),
        activeWhen: isAlwaysActive ? () => true : `/${name}`,
        customProps: {
            ...commonProps,
            ...props,
        },
    });
    registerApplication({
        name: cssModuleName,
        app: async () => {
            const link = document.createElement('link');
            return {
                async bootstrap() {
                    const defaultImports = await window.importMapOverrides.getDefaultMap();
                    const overrideImports = window.importMapOverrides.getOverrideMap();
                    const finalImports = window.importMapOverrides.mergeImportMap(defaultImports, overrideImports);
                    const cssModuleUrl = finalImports.imports[cssModuleName];
                    link.rel = 'stylesheet';
                    link.href = cssModuleUrl;
                    link.type = 'text/css';
                },
                async mount() {
                    document.head.append(link);
                },
                async unmount() {
                    link.remove();
                },
            };
        },
        activeWhen: () => true,
        customProps: {
            ...commonProps,
            ...props,
        },
    });
};
